import { config } from '@/pageConfig/homeowners/fr/en';
import { HomeownersPageTemplate } from '@/pageTemplate/HomeownersPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function HomeownersPage() {
  const { trackEvent } = useAnalyticsContext();
  useEffect(
    () =>
      trackEvent('homeowners_page.viewed', {
        lang: 'en-FR',
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return <HomeownersPageTemplate config={config} />;
}
